<div class="canvas-holder">
  <canvas #chartCanvas></canvas>
  @if (isEmpty) {
    <div class="no-data-watermark">{{ LL.trendChart.noData() }}</div>
  }
</div>
